import  gql  from 'graphql-tag'

export const SHARE_AGROSTUDYDOCS_EMAIL = gql`mutation shareAgroStudyDocsByEmail($input: ShareAgroStudyDocsMutationInput!){
    shareAgroStudyDocsByEmail(input: $input){
        errors{
            field
            messages
        }
    }
}`;